export default {
  'moduleTitle.address': 'Address',
  'moduleTitle.address_details': 'Address Details',
  'moduleTitle.activity_details': 'Activity Details',
  'moduleTitle.add_log': 'Add Log',
  'moduleTitle.award_level': 'Award Level',
  'moduleTitle.adventurous_journey': 'Adventurous Journey',
  'moduleTitle.already_assessed': 'Already Assessed!',
  'moduleTitle.approved': 'Approved!',
  'moduleTitle.assessor_details': 'Assessor Details',
  'moduleTitle.authorising_contact_license_holder': 'Authorising Contact / Licence Holder',
  'moduleTitle.category_journey_details': '{category} Journey Details',
  'moduleTitle.complete_report': 'Complete Report',
  'moduleTitle.completed_progress': 'Completed {finished} / {total}',
  'moduleTitle.congratulation': 'Congratulations!',
  'moduleTitle.confirming_email_address': 'Confirming email address ...',
  'moduleTitle.contact_details': 'Contact Details',
  'moduleTitle.edit_log': 'Edit Log',
  'moduleTitle.event_journey': '{event} Journey',
  'moduleTitle.forgotten_password': 'Forgotten Password',
  'moduleTitle.great_you_are_almost_there': 'Privacy Policy',
  'moduleTitle.home_address': 'Home Address',
  'moduleTitle.postal_address': 'Postal Address',
  'moduleTitle.journey_overview': 'Journey Overview',
  'moduleTitle.log_detail': 'Log Details',
  'moduleTitle.login': 'Login',
  'moduleTitle.new_activity': 'New Activity',
  'moduleTitle.new_event_journey': 'New {event} Journey',
  'moduleTitle.new_residential_project': 'New Residential Project',
  'moduleTitle.notRegistred': 'Not Registered?',
  'moduleTitle.nominated_award_leader_contact_details': 'Award Coordinator Contact Details',
  'moduleTitle.nominated_award_leader': 'Award Coordinator',
  'moduleTitle.organisation_address': 'Organisation Address',
  'moduleTitle.organisation_details': 'Organisation Details',
  'moduleTitle.online_record_book_account': 'Online Record Book Account',
  'moduleTitle.page_not_found': '404 - Page not found',
  'moduleTitle.personal_details': 'Personal Details',
  'moduleTitle.preparation_and_training': 'Preparation and Training',
  'moduleTitle.profile_guardian_consent': 'Parent / Guardian Consent',
  'moduleTitle.profile_questions': 'Profile Questions',
  'moduleTitle.registration_for_level': 'Registration for next level',
  'moduleTitle.residential_project': 'Residential Project',
  'moduleTitle.residential_project_details': 'Residential Project Details',
  'moduleTitle.reset_password': 'Reset Password',
  'moduleTitle.welcome_to_the_orb': 'Welcome to the Online Record Book',
  'moduleTitle.we_have_sent_you_an_email': 'We have sent you an email with an activation link.',
  'moduleTitle.your_registration_is_complete': 'Your registration is complete',
  'formTitle.activity_details': 'Activity Details',
  'formTitle.assessor_details': 'Assessor Details',
  'formTitle.supervisors_details': 'Supervisor Details',
  'formTitle.preparation_and_training_activities': 'Preparation and Training Activities',
  'formTitle.added_preparation_activities': 'Added Preparation and Training Activities',
  'label.add_picture': 'Add Picture',
  'label.address_first_line': 'Address First Line',
  'label.address_second_line': 'Address Second Line(Optional)',
  'label.are_you_already_running_award': 'Are you already running the Award?',
  'label.are_you_the_main_award_leader': 'Are you the Main Award Leader or Coordinator for your Award Unit?',
  'label.award_participant': 'Award Participant',
  'label.award_leader': 'Award Leader',
  'label.birthdate': 'Date of Birth',
  'label.category': 'Category',
  'label.change_locale': 'Change Location',
  'label.choose_project': 'Choose Activity',
  'label.city': 'City',
  'label.choose_as_major_activity': 'Choose as Major activity',
  'label.date': 'Date',
  'label.date_of_birth': 'Date of Birth',
  'label.description_of_progress': 'Description of your progress',
  'label.duration': 'Duration (Hours / Mins)',
  'label.email': 'Email',
  'label.email_address': 'Email address',
  'label.email_again': 'Confirm email',
  'label.employment_status': 'Employment Status',
  'label.end_date': 'End Date',
  'label.enter_his_email': 'Enter Email Address',
  'label.entered_transaction_id': 'Your Transaction ID',
  'label.first_name': 'First Name',
  'label.gender': 'Gender',
  'label.goal': 'Goal',
  'label.journey_activity': 'Journey Activity',
  'label.journey_objective': 'Journey Goal',
  'label.journey_observations': 'Journey Observations',
  'label.journey_type': 'Journey Type',
  'label.last_name': 'Last Name',
  'label.level': 'Level',
  'label.location': 'Location',
  'label.logout': 'Logout',
  'label.major': 'Major',
  'label.middle_name': 'Middle Name',
  'label.mode_of_transport': 'Mode of Transport',
  'label.my_award_leader': 'My Award Leader',
  'label.name': 'Name',
  'label.nationality': 'Nationality',
  'label.no': 'No',
  'label.no_results': 'No results',
  'label.note': 'Note',
  'label.note_for_assessor': 'Note for Assessor',
  'label.note_for_leader': 'Note for Leader',
  'label.optional': 'optional',
  'label.organisation_name': 'Organisation Name',
  'label.organisation_type': 'Organisation Type',
  'label.others': 'Others',
  'label.password': 'Password',
  'label.password_again': 'Repeat Password',
  'label.project_location': 'Project Location',
  'label.pay_online': 'Pay Online',
  'label.pay_award_leader_or_unit': 'Pay Award Leader or Unit',
  'label.payment_not_required': 'Payment not required from participant',
  'label.payment_type': 'Payment Type:',
  'label.phone': 'Phone',
  'label.phone_number': 'Phone number',
  'label.phone_type': 'Phone type',
  'label.profile': 'Profile',
  'label.reset_password': 'Reset Password',
  'label.region': 'State/Province/Region',
  'label.relationship': 'Relationship to Participant',
  'label.role_in_organisation': 'Role in Organisation',
  'label.select_country': 'Select Country',
  'label.select_your_au': 'Select your Award Unit',
  'label.start_typing': 'Start typing',
  'label.start_date': 'Start Date',
  'label.select': 'Select',
  'label.select_async': 'Start typing...',
  'label.select_your_operating_authority': 'Select your Operating Authority',
  'label.specify_category': 'Please specify your category',
  'label.subcategory': 'Subcategory',
  'label.title': 'Title',
  'label.username': 'Username',
  'label.what_is_your_role': 'What is your role in your organisation?',
  'label.where_have_you_completed': 'Where have you completed?',
  'label.yes': 'Yes',
  'label.your_changes_havent_been_saved': "Your changes haven't been saved. Data will be lost.",
  'label.zip': 'Zip / Post Code',
  'label.adventurous_journey': 'Adventurous Journey',
  'label.after_your_journey_describe': 'Describe your observations from your journey in a few sentences.',
  'label.because_your_age_is_under_18': 'Because you are under the age of 18, we need consent from your Parent/Guardian. ',
  'label.before_you_head_to_journey': 'Before you can continue with your Qualifying Journey, you must first complete the Preparation and Training.',
  'label.before_entering_new_level': 'Before entering the next level please confirm that your personal details are still up to date.',
  'label.bring_required_amount_to_your_award_leader': 'Bring required amount to your Award Leader or Award Coordinator in your Unit.',
  'label.do_you_have_any_other_level': 'Have you completed any previous levels of the Award?',
  'label.do_you_know_who_is_your_award_leader': 'Do you know who your Award Leader is?',
  'label.going_on_an_expedition': 'Going on an expedition gives you the chance to have an adventure, work as a team, and act on your own initiative.',
  'label.going_on_residential_gives_chance': 'Going on a residential gives you the chance to learn how to work with people from different backgrounds and build confidence living in new environments.',
  'label.i_confirm_that_i_meet': 'I confirm that I meet all NAO Regulation Requirements.',
  'label.i_agree_to_volunteer_code': "I Agree to the Volunteer Code of Conduct. For more information <a href='{url}' target='_blank'>click here</a>.",
  'label.i_have_read_the_terms_and_conditions': 'I have read the Terms and conditions and agree with them.',
  'label.i_will_bring_the_consent_to_my_award_leader_later': 'I will bring the consent to my Award Leader later',
  'label.if_you_are_from_orphanage': 'For example, If your school or youth organisation pays on your behalf.',
  'label.here_you_can_add_activity': 'Here you can add an extra Preparation and Training Activity.',
  'label.how_do_you_want_to_apply': 'How do you want to apply:',
  'label.my_parent_consent_has_been_already_given': 'My parent/guardian consent has already been given to my Award Leader.',
  'label.my_parent_will_confirm_consent_by_email': 'My parent/guardian will confirm consent by email',
  'label.major_activity_means_that_you_have_to_spent': 'Major activity means that you have to spend an extended amount of time on this activity compare to others. For Gold and Silver the extra time required is six months, for Bronze it is three months.',
  'label.not_sure_about_your_auth': 'If you are unsure which Award Authority you should register to, please contact your Regional Office.',
  'label.page_not_found': '404 - Page not found.',
  'label.please_fill_in_the_following': 'Please fill in the following details for the authorising contact / licence holder at your organisation',
  'label.register_a_new_account_as': 'Register a new account as:',
  'label.residential_project': 'Residential Project',
  'label.select_your_award_unit': 'Select your Award Unit',
  'label.the_expedition_can_be_faraway': 'The expedition can be as far away or as close to home as you want it to be, and there are hundreds of ways you can go about it.',
  'label.to_log_your_process_on_orb': 'Please set a password below to complete the creation of your Online Record Book account.',
  'label.waiting_for_assessment': 'Awaiting Assessment.',
  'label.waiting_for_sign_off': 'Awaiting Award Leader Sign-off.',
  'label.we_have_sent_you_an_email': 'We have sent you an email with an activation link.',
  'label.what_level_of_the_award': 'What level of the Award are you registering for?',
  'label.you_are_now_registering_as_participant': 'You are now registering as an Award participant.',
  'label.you_are_now_registering_as_award_unit': 'You are now registering as an Award Unit.',
  'label.you_can_use_my_photos_for_promotional_purposes': 'As an Award participant, I give my consent for the Foundation to use my photographs / pictures for promotional purposes.',
  'label.you_can_send_activity_for_approval': 'You can send now your Activity to Assessor for approval.',
  'label.you_can_send_activity_for_leader': 'You can now send  your Activity to your Award Leader for approval.',
  'label.you_can_send_residential_project_to_leader': 'You can now send your Residential Project to your Award Leader for approval.',
  'label.you_have_finished_now_send_to_approval': 'Your Activity is finished. You can now submit it to your Assessor for approval. You can also add a personal note below.',
  'label.preparation_and_training': 'Preparation and Training',
  'label.you_will_be_redirected_to_the_payment': 'Click the Pay button below to pay online using your Visa, MasterCard credit card or Visa debit card.',
  'label.you_will_be_the_first_award_leader': 'You will be the first Award Leader in your organisation. You will have rights to add more Award Leaders, Participants and manage the process of the award through the Online Record Book system.',
  'label.youll_receive_a_notification': 'You will receive a notification when your Award Leader has approved your registration. You can log on to the Online Record Book <a>here</a> (until your Award Leader has approved your registration you will only have limited functionality).',
  'label.your_parent_email': 'Your parent/guardian Email',
  'label.your_parent_first_name': 'Your parent/guardian First Name',
  'label.your_parent_last_name': 'Your parent/guardian Last Name',
  'label.your_report_approve_now_send_to_leader': 'Your Report has been approved! You can now submit it to your Award Leader for approval. You can also add a personal note below.',
  'label.there_are_loads_of_exciting_possibilities': 'There are loads of exciting possibilities and opportunities. Choose something which you will find fulfilling.',
  'label.your_residential_project_has_been_setup': 'Your Residential Project has been set up and sent to your Award Leader for approval.',
  'label.your_report_has_been_sent_assessor': 'Your Report has been sent to your Assessor for approval.',
  'label.your_report_has_been_sent_leader': 'Your Report has been sent to your Award Leader for approval.',
  'label.your_residential_project_is_complete': 'Your Residential Project is complete.',
  'label.to_work_on_the_online': 'To work on the Online Record Book (ORB) you need a personal ORB account.',
  'label.we_will_send_you_an_email': 'We will send you an email when your ORB account registration is approved.',
  'label.if_you_have_any_problems_or_doubts': 'If you have any problems or doubts please contact you award unit for more information.',
  'label.are_you_sure_you_want_to_leave': 'Are you sure you want to leave? Data will be lost.',
  'label.no_logs_yet': 'No logs yet.<br />Try to add your first log by presssing the "Add Log" button.',
  'label.menu': 'Menu',
  'label.postal_address_different': 'My postal address is different',
  'notifications.award_unit_has_been_created': 'Award Unit has been created',
  'notifications.authorization_code_is_not_valid': 'Authorisation code is not valid - it looks like you have previously used this code',
  'notifications.email_has_been_confirmed': 'Email address has been confirmed',
  'notifications.leader_has_been_created': 'Leader has been created',
  'notifications.participant_has_been_created': 'Participant has been created',
  'notifications.email_with_instructions_has_been_sent': 'Email with instructions has been sent',
  'notifications.your_new_password_has_been_set': 'Your new password has been set',
  'notifications.success': 'Success',
  'notifications.unknown_role': 'Unknown role',
  'notifications.waiting_for_approval': 'Waiting for approval',
  'notifications.activity_cannot_be_created': 'Activity cannot be created until your registration is approved',
  'notifications.new_activity_has_been_added': 'New activity has been added',
  'notifications.new_log_has_been_added': 'New log has been added',
  'notifications.log_has_been_deleted': 'Log has been deleted',
  'notifications.log_has_been_modified': 'Log has been modified',
  'notifications.adventurous_journey_cannot_be_created_until_approved': 'Adventurous Journey cannot be created until your registration is approved',
  'notifications.new_participant_event_has_been_added': 'New participant event has been added',
  'notifications.participant_event_has_been_completed': 'Participant event has been completed',
  'notifications.training_and_practice_modified': 'Training and Practice has been modified',
  'notifications.completion_residential_project_completed': 'Residential project has been completed',
  'notifications.new_residential_project_has_been_added': 'New residential project has been added',
  'notifications.residential_project_cannot_be_created_until_approved': 'Residential project cannot be created until your registration is approved',
  'notifications.already_assessed_sent': 'Leader approval request has been sent',
  'notifications.assessment_request_sent': 'Assessment request has been sent',
  'notifications.leader_approval_sent': 'Leader approval request has been sent',
  'tabs.logs': 'Logs',
  'tabs.new': 'New',
  'tabs.overview': 'Overview',
  'tabs.report': 'Report',
  'button.add_activity': 'Add Activity',
  'button.add_log': 'Add Log',
  'button.continue_here': 'Continue here',
  'button.continue': 'Continue',
  'button.continue_to_award': 'Continue to Award',
  'button.delete': 'Delete',
  'button.edit': 'Edit',
  'button.edit_log': 'Edit Log',
  'button.finish': 'Finish',
  'button.forgot_your_password': 'Forgot your password?',
  'button.i_already_have_assessment': 'I already have an assessment',
  'button.leave_anyway': 'Leave anyway',
  'button.login': 'Log in',
  'button.no': 'No',
  'button.register': 'Register',
  'button.send': 'Send',
  'button.send_for_approval': 'Send for approval',
  'button.setup': 'Setup',
  'button.setup_residential': 'Set up Residential Project',
  'button.stay': 'Stay',
  'button.submit': 'Submit',
  'button.update': 'Update',
  'button.yes': 'Yes',
  'errors.at_least_num_characters': 'At least {length} characters long',
  'errors.do_not_match': 'Do not match',
  'errors.include_at_least_one_number': 'Include at least one number character',
  'errors.include_both_lower_and_upper_case': 'Include both lower and upper case characters',
  'errors.invalid_phone_format': 'Invalid phone format',
  'errors.invalid_email_address': 'Invalid email address',
  'errors.required_field': 'Required field',
  'errors.must_be_at_least': 'Must be at least {min} characters',
  'errors.must_be_no_more_than': 'Must be no more than {max} characters',
  'errors.must_be_an_integer': 'Must be an integer',
  'errors.must_contain_at_least': 'Must contain at least one number',
  'errors.must_include_at_least': 'Must include at least one upper case characters',
  'errors.must_be_one_of': 'Must be one of: {enums}',
  'errors.you_must_be_younger_than': 'You must be younger than {years} years and {months} months to register for the Award. Please speak with your Award Unit Staff about this.',
  'errors.you_must_be_older_than': 'You must be older than {years} years and {months} months to register for the Award. Please speak with your Award Unit Staff about this.',
  'errors.email_address_is_in_use_please_sign': 'E-mail address is already in use, if you want to register for another level, please sign in to your account.',
  'errors.email_address_is_in_use': 'E-mail address is already in use.',
  'errors.sorry_we_already_have_this_email': "Sorry we already have an account with this email registered. If you want to start the next level, <a href='/'>log to your account</a> and select option Start next Level.",
  'wizard.authorising_contact': 'Authorising Contact',
  'wizard.award_leader_contact': 'Award Leader Contact',
  'wizard.award_unit_details': 'Award Unit Details',
  'wizard.contact_details': 'Contact Details',
  'wizard.contacts': 'Contacts',
  'wizard.level': 'Award Level',
  'wizard.level_selection': 'Award Selection',
  'wizard.leader_details': 'Leader Details',
  'wizard.nominated_award_leader': 'Award Coordinator',
  'wizard.orb_account': 'ORB Account',
  'wizard.parent_consent': 'Parent Consent',
  'wizard.participant_details': 'Participant Details',
  'wizard.profile': 'Profile',
  'wizard.payment': 'Payment',
  'wizard.select_award_unit': 'Select Award Unit',
  'wizard.unit_details': 'Unit Details',
  'wizard.welcome': 'Welcome',
  'wizard.your_details': 'Your Details',
  'awardUnit.do_you_want_to_create': 'Do you want to create a new Award Unit?',
  'parent.you_can_download_the_consent_here': 'You can download the Parental Consent Form here if you do not already have it. Get it signed by your Parent/Guardian and return it to you Award Leader.',
  'footer.copyright': "&copy; Copyright The Duke of Edinburgh's International Award 2018",
  'registration_participant.required_award_payment': 'Required Award Payment',
  'registration_participant.pay_online_here': 'Pay online and get your transaction id here.',
  'dashboard.activity_log_time': '{hours}h {minutes}min',
  'moduleTitle.award_completed': 'Award completed!',
  'notifications.award_approval_request_sent_to_leader': 'Award approval request has been sent to your leader',
  'notifications.new_participant_event_has_been_completed': 'New participant event has been completed',
  'notifications.preparation_and_training_approval_sent': 'Preparation and training approval has been sent',
  'notifications.reparation_and_training_completed': 'Preparation and Training has been completed',
  'notifications.your_profile_photo_has_been_edited': 'Your profile photo has been edited',
  'notifications.your_profile_has_been_edited': 'Your profile has been edited',
  'notifications.new_level_has_started': 'Next level has started',
  'notifications.activity_has_been_edited': 'Activity has been edited',
  'notifications.you_have_been_logged_out': 'Logging out...',
  'notifications.logging_out': "You've been logged out",
  'label.you_can_send_award_to_leader': 'You can send your Award to your Award Leader for approval',
  'label.you_have_completed_all_sections_of_your_award': 'You have completed all sections of your Award. You can now submit it to your Award Leader for approval. You can also add a personal note below.',
  'label.you_have_now_completed_your_award': 'You have now completed your {level} Award. Would you like to start the next level?',
  'label.congratulation_your_award_has_been_approved': 'Congratulations. Your {level} Level award has been approved! <br /> If you want, you can already start next level.',
  'moduleTitle.settings': 'Settings',
  'moduleTitle.edit_activity': 'Edit Activity',
  'moduleTitle.select_your_major_activity': 'Select your Major Activity',
  'label.settings': 'Settings',
  'label.major_activity_means_that_you_will': 'Major Activity means that you will have to spend an extended amount of time on this activity compared to the others. For Gold and Silver the extra time required is six months, for Bronze it is three months.',
  'label.notifications': 'Notifications',
  'label.my_award': 'My Award',
  'label.physical_recreation': 'Physical Recreation',
  'label.skill': 'Skill',
  'label.service': 'Service',
  'label.my_parent_will_complete_and_sign_form': 'My parent/guardian will complete and sign the parent/guardian Consent form',
  'label.please_print_it_tak_it_to_your_parent': 'You can download the Parent / Guardian consent for below. Please take it to your Parent / Guardian to sign, and then give it to your Award Leader',
  'label.change_password': 'Change Password',
  'label.change_major_activity': 'Change Major Section',
  'title.change_password': 'Change Password',
  'label.old_again': 'Old Password',
  'label.new_password': 'New Password',
  'label.new_password_again': 'New Password again',
  'errors.passwords_dont_match': 'Passwords do not match',
  'errors.more_than': 'More than {limit}',
  'button.parent_guardian_consent_pdf': 'Parent/guardian consent.pdf',
  'button.send_award_for_approval': 'Send Award for approval',
  'button.send_report': 'Send report',
  'button.terms_and_conditions': 'International Terms & Conditions',
  'button.privacy_policy': 'Privacy Policy',
  'button.save': 'Save',
  'button.start_new_level': 'Start Next Level',
  'button.change_password': 'Change Password',
  'button.edit_activity': 'Edit Activity',
  'moduleTitle.file_upload': 'File Upload',
  'label.add_file': 'Add File',
  'label.description': 'Description',
  'label.waiting_for_office_sign_off': 'Awaiting Award Office Sign-off.',
  'notifications.file_has_been_uploaded': 'File has been uploaded',
  'tabs.files': 'Files',
  'button.upload': 'Upload',
  'button.upload_file': 'Upload File',
  'button.add_file': 'Add File',
  'button.this_activity_has_no_assessor': 'This activity has no Assessor. You must set the Assessors details before sending it for approval.',
  'label.i_want_to_register_my_award': 'I want to register my Award Unit as Independent Award Centre',
  'label.select_sub_operating_authority': 'Select sub Operating Authority',
  'label.your_must_first_setup_some_activity': 'Your must first setup some activity',
  'label.you_cant_change_your_major_activity': "You can't change your major activity. Your major activity has already been completed",
  'label.s_specific': "<b>S-Specific: Your Goal shouldn't be too broad.</b> Instead of setting; ‘I want to be better at violin’, you could say, ‘I would like to master F scale in playing the violin’.",
  'label.m_measurable': '<b>M-Measurable: You should be able to tell when you have completed your goal.</b> Instead of setting your goals as ‘I want to help the community’, you could say, ‘I want to help out the people who visit soup kitchens by volunteering once a week’. This way the goal can be tested.',
  'label.a_achievable': '<b>A-Achievable: Your Goal should be something you can achieve in your specific Award time frame.</b> Rather than saying ‘I want to end poverty’, it would be best to set a more practical goal such as ‘I would like to raise funds to send overseas to help alleviate poverty in a third world village.’',
  'label.r_realistic': '<b>R-Realistic: This is basically the same as ‘Achievable’.</b> Is it ‘Realistic’ that you can achieve your goals in that time frame?',
  'label.t_timely': '<b>T-Timely: Your goal should include when you would like to have the goal completed by.</b> Your Goal could perhaps be, ‘I would like to master the F scale in violin within three months.’',
  'label.you_can_upload_here_any_files': 'You can upload any files (10mb or smaller)  you want to share with your Award Leader here.',
  'moduleTitle.login_change': 'Login Change',
  'notifications.adventurous_journey_modified': 'Adventurous Journey has been modified',
  'tabs.sections': 'Sections',
  'label.change_email': 'Change Email',
  'title.change_email': 'Change Email',
  'label.new_email': 'New Email',
  'label.new_email_again': 'Confirm new email',
  'errors.emails_dont_match': 'Emails do not match',
  'button.change_email': 'Change Email',
  'notifications.email_with_instructions_has_been_sent_to_your_inbox': 'Email with instructions has been sent to your inbox',
  'global.dofe_name': 'The Duke of Edinburgh’s International Award',
  'global.or': 'or',
  'route.landing_page': 'Landing page',
  'route.dashboard': 'Dashboard',
  'moduleTitle.notifications': 'Notifications',
  'moduleTitle.no_notifications': 'No notifications',
  'moduleTitle.new_notifications': 'New notifications',
  'moduleTitle.older_notifications': 'Older notifications',
  'moduleTitle.user_guide': 'User Guides',
  'label.user_guide': 'User Guides',
  'notifications.your_password_has_been_changed': 'Your password has been changed',
  'label.country': 'Country',
  'label.on_your_smartphone': 'On your smartphone',
  'label.on_the_web': 'On the web',
  'label.orb_online': 'ORB Online',
  'label.language': 'Language',
  'moduleTitle.participant_login': 'Participant login',
  'label.for_ios': 'for iOS',
  'label.for_android': 'for Android',
  'button.login_as_award_staff': 'Login as Award Staff',
  'errors.leader_doesnt_exist': 'Leader does not exist',
  'global.loading': 'Loading',
  'moduleTitle.award_staff_login': 'Award Staff login',
  'formTitle.residential_project_details': 'Residential Project Details',
  'label.you_can_also_download_participant': 'You can also download our <strong>Participant App</strong> to  access the Online Record Book anytime, anywhere.',
  'label.you_can_also_download_leader': 'You can also download our <strong>Award Leader App</strong> to access the Online Record Book anytime, anywhere.',
  'notifications.this_role_is_not': 'This role is not currently supported',
  'notifications.residential_project_has_been_updated': 'Residential project has been updated',
  'tabs.participant': 'Participant',
  'tabs.award_staff': 'Award Staff',
  'moduleTitle.edit_residential_project': 'Edit Residential Project',
  'button.residential_project': 'Edit Residential Project',
  'notifications.your_login_email_has_been_changed': 'Your login email has been changed',
  'meta.dofe_name': 'The Duke of Edinburgh’s International Award',
  'notifications.unknown_role_leader': 'Unknown role - Use Award Staff login',
  'notifications.unknown_role_participant': 'Unknown role - Use Participant login',
  'label.user_guide_web_participant': 'User web guide - Participant',
  'label.user_guide_app_participant': 'User app guide - Participant',
  'label.note_for_supervisor': 'Note for Supervisor',
  'label.before_submitting_your_aj': 'Before sending your Journey to Award Leader, you first need approval from your {role}. If you want, you can add a note here.',
  'button.back_to_home': 'Back to Home',
  'moduleTitle.assessor_approval': '{role} Approval',
  'label.this_aj_has_no_assessor': 'This Adventurous Journey has no {role}. You must update the details before sending it for approval.',
  'route.not_found': 'Not Found',
  'notifications.are_you_sure': 'Are you sure?',
  'button.cancel': 'Cancel',
  'label.add_document': 'Add document',
  'errors.there_are_currently_no_details_for_your': 'There are currently no details for your {role}. Please fill in the missing details before submitting your Activity for assessment',
  'moduleTitle.missing_data': 'Missing data',
  'label.to_send_assessment_request': "If you would like to send assessment request electronically, please fill {role}'s email",
  'label.pending_changes': 'Pending changes ...',
  'label.some_fields_require': 'Some fields require your attention',
  'roles.assessor': 'Assessor',
  'roles.supervisor': 'Supervisor',
  'pageTitle.register_participant': 'Register participant',
  'moduleTitle.revise_message': 'Revise Message',
  'moduleTitle.payment_for_level': 'Payment for {awardLevel}',
  'moduleTitle.payment': 'Participant registration fees payment',
  'moduleTitle.we_have_sent_you_payment_link': 'We have sent you an email with a link to the Payment Gateway.',
  'label.required_award_payment': 'Required award payment',
  'label.payment_fees': 'payment Fees',
  'label.payment_method': 'Payment Method',
  'label.you_will_type_trans_id': 'You will be asked to type in your transaction ID.',
  'label.any_level_previously': 'Any level previously completed',
  'label.registering_for_level': 'Registering for level',
  'notification.payment_link_expired': 'Payment linked is expired',
  'button.pay': 'Pay',
  'label.registration_updated': 'The registration has been updated, you may now close this page.',
  'label.award_leader_receive_payment': 'The Award Leader will receive information about the payment.',
  'errors.end_date_after': 'End date has to be after start date',
  'button.back': 'Back',
  'button.edit_info': 'Edit info',
  'moduleTitle.level_detail': 'Level Details',
  'label.payment_methods': 'Payment Methods',
  'label.address': 'Address',
  'label.postal_address': 'Postal address',
  'note.review_filled_participant': 'Please review info filled by Participant. If you find some incorrect, you can edit them.',
  'moduleTitle.payment_successful': 'Participant registration payment was successful',
  'button.proceed_to_login': 'Proceed to login',
  'label.add_additional_activity': 'Add additional activity',
  'moduleTitle.welcome_to_orb': 'Welcome to Online Record Book',
  'empty_dashboard.not_approved': 'This tool will help you record your progress during your Award. But your profile is not approved yet by your Award Leader. Before you start creating your first activity, you will have to wait for the approval.',
  'empty_dashboard.approved_1': 'This tool will help you record your progress during your Award.',
  'empty_dashboard.approved_2': 'First you have to set up your an activity. To start, click on one of the left.  If you need some help with activity setup, ask your Award Leader for assistance.',
  'label.discuss_activity_leader': 'If you are selecting more than one activity, please discuss this with your Award Leader first.',
  'label.cannot_add_activity': 'You can add a maximum of 3 activities for this category. Please discuss this with your Award Leader.',
  'button.ok': 'OK',
  'label.payment_was_canceled': 'Payment was canceled by user.',
  'label.problem_with_payment': 'There was a problem processing your payment. Please contact your National Award Operator (NAO).',
  'pageTitle.register_leader': 'Register Leader',
  'pageTitle.registration_complete': 'Registration Completed',
  'label.payment_link_expired_or_paid': 'You have already paid for the payment registration fees OR the payment link has expired.',
  'label.contact_nao_assistance': 'Contact your NAO if you need assistance.',
  'label.send_required_amount_to_your_award_leader': 'Send required amount to your Award Leader or Award Coordinator in your Unit.',
  'label.fee_can_be_paid': 'Fee can be paid online using VISA, Master Card or Credit Debit Cards.',
  'notifications.login_failed_right_tab': 'Login unsuccessful. Make sure you are in the correct tab (Participant / Award Staff).',
  'label.i_have_read_privacy_policy': 'I have read the Privacy Policy and agree with it.',
  'errors.invalid_date_format': 'Invalid date format',
  'label.no_privacy_policy': 'You can proceed by clicking the finish button.',
  'label.status': 'Status',
  'moduleTitle.attached_with_observation': 'Attached with observation',
  'moduleTitle.revise_message_rp': 'Your Residential Project has been revised by your Award Leader.',
  'file.activity_section_summary': '{section}-section-summary',
  'label.download_section_summary': 'Download section summary',
  'label.award_summary': 'Award Summary',
  'btn.download_summary_for_assessor': 'Download summary for Assessor',
  'label.first_activity_started': 'First activity started',
  'label.hours_completed_required': 'Hours Completed/Required',
  'label.weeks_completed_required': 'Weeks Completed/Required',
  back_to_home: 'Back to home',
  'label.activity_rejected_click': 'Your activity has been returned by your Award Leader. Click for ',
  'button.more_information': 'more information',
  'label.attached_file': 'Attached file',
  'moduleTitle.journey_details': 'Journey Details',
  'tabs.activity': 'Activity',
  'label.confirm_email': 'Confirm email',
  'label.aj_rejected_click': 'Your journey has been returned by your Award Leader. Click for ',
  'label.verifying_payment': 'Verifying Payment',
  'button.finish_and_pay': 'Finish and Pay',
  'label.payment_not_successful_text': 'As you have not successfully completed the payment of the award, it is necessary to make the payment now',
  'label.payment_not_completed': 'Payment not completed',
  'button.pay_now': 'Pay Now',
  'label.registration_pending_parental_consent': 'Your registration is pending Guardian / Parent consent',
  'button.edit_observation': 'Edit Observation',
  'moduleTitle.qualifying': 'Qualifying',
  'moduleTitle.practice': 'Practice',
  'label.first_log_entry': 'First Log Entry',
  'label.first_log_entry_date': 'First Log Entry Date',
  'label.last_log_entry': 'Last Log Entry',
  'label.last_log_entry_date': 'Last Log Entry Date',
  'label.you_can_send_journey_report_for_approval': 'You can send your {journey} Journey report for approval.',
  'button.edit_and_resend_report': 'Edit and resend report',
  'label.your_journey_is_complete': 'Your {journeyType} Journey is complete.',
  'button.add_additional_journey': 'Add additional Journey',
  'moduleTitle.edit_journey': 'Edit Journey',
  'notifications.assessment_sent': 'Assessment has been sent',
  'notifications.file_is_too_big': 'File could not be uploaded. The file size limit is 10mb.',
  'notifications.authorization_code_has_expired': 'Authorisation code has expired for security, please request a new code',
  'route.confirm_email': 'Confirm email',
  'label.assessor_needs_account': 'To work on the Online Record Book (ORB) you need a personal ORB account.<br/>Please create your details here',
  'label.company_name': 'Company Name',
  'label.secondary_email_again': 'Confirm Secondary Email',
  'label.how_many_years': 'How many years/months?',
  'label.no_company_leave_empty': "If you don't work for any company, leave empty",
  'label.secondary_phone_number': 'Secondary Phone Number',
  'label.secondary_phone_type': 'Secondary Phone Type',
  'label.wwc_application_number': 'Child Protection Number',
  'label.wwc_expiration_date': 'Child Protection expiration date',
  'label.you_are_now_registering_as_assessor': 'You are now registering to become an Assessor',
  'label.you_have_finished_aj_now_send_to_approval': 'Your Adventurous Journey is finished. You can now submit it to your Assessor for approval. You can also add a personal note below.',
  'label.your_experience': 'Your Experience',
  'label.your_qualification': 'Your Qualification',
  'notifications.waiting_for_assessor_approval': 'Waiting for Assessor approval',
  'button.resend_assessment_request': 'Resend Assessment Request',
  'errors.emails_must_be_different': 'Secondary email must be different than the primary one.',
  'moduleTitle.company_details': 'Company Details',
  'notifications.already_resent_assessment_request': 'You have already resent the assessment request',
  'route.assessor_dashboard': 'Assessor Dashboard',
  'pageTitle.register_assessor': 'Register Assessor',
  'wizard.assessor_details': 'Assessor Details',
  'wizard.assessor_experience': 'Assessor Experience',
  'wizard.personal_details': 'Personal Details',
  'button.sign_off': 'Sign Off',
  'button.sign_off_dashed': 'Sign-Off',
  'moduleTitle.sign_off': 'Sign Off',
  'label.certify_participant_met_reqs': 'I Certify That as the Assessor of this activity that the participant has met the requirements.',
  'label.assessor_report': 'Assessor Report',
  'label.content_update': 'Please wait. Updating content...',
  'label.comment_on_participant_improvement': "Please comment on the participant's improvement/performance commitment",
  'note.edit_participant_review': 'To correct any of this information click on the Edit info button.',
  'errors.min_age': 'Min age is {age}',
  'notifications.assessor_link_expired': 'Assessor registration link has expired.',
  'label.secondary_email': 'Secondary Email',
  'moduleTitle.review_participant_info': 'Review participant info',
  'label.loading_payment_gateway': 'Loading Payment Gateway',
  'label.consent_given_login_as_child': 'Consent was already given. Please login as your child.',
  'notifications.only_one_qualification_journey_per_award': 'Only one Qualifying Adventurous Journey can be set-up within the Award',
  'label.registration_fees_participant': 'Registration fees payment - {name} (#{id})',
  'moduleTitle.leader_details': 'Award Leader Details',
  'label.leader_name': 'Award Leader Name',
  'label.leader_phone': 'Award Leader Phone',
  'label.leader_email': 'Award Leader Email',
  'moduleTitle.au_details': 'Award Unit Details',
  'label.au_name': 'Award Unit Name',
  'label.assessor_guidelines': 'Guidelines',
  'label.assessor_cond_req': 'Key conditions and requirements',
  'label.assessor_ref_handbook': 'Reference to award handbook',
  'label.assessor_ref_online_modules': 'Reference to online learning modules',
  'label.participant_has_no_aj_report': 'Participant has not submitted a report yet.',
  'moduleTitle.participant_details': 'Participant Details',
  'label.participants_has_no_logs': 'Participant has no logs yet.',
  'label.location_type': 'Location Type',
  'label.activity_ready_for_signoff': 'This activity is ready for sign off.',
  'label.activities': 'Activities',
  'label.choose_how_you_want_to_login': 'Choose how you want to login:',
  'roles.leader': 'Leader',
  'roles.award_verifier': 'Award Verifier',
  'roles.coordinator': 'Coordinator',
  'roles.aj_assessor': 'Adventurous Journey Assessor',
  'roles.aj_supervisor': 'Adventurous Journey Supervisor',
  'roles.instructor': 'Instructor',
  'roles.nao_staff': 'NAO Staff',
  'roles.super_user': 'Super-user',
  'roles.user': 'User',
  'roles.viewer': 'Viewer',
  'roles.authorizing_contact': 'Authorizing Contact',
  'roles.if_staff_superuser': 'IF Staff Superuser',
  'roles.if_staff_statistical_user': 'IF Statistical User',
  'roles.if_staff_viewer': 'IF Staff Viewer',
  'roles.aj_instructor': 'AJ Instructor',
  'label.if_you_have_questions_au': 'If you have any questions about your registration, please contact your Award Unit.',
  'label.we_will_send_you_an_email_leader': 'We will send you an email when your ORB account registration is approved.',
  'moduleTitle.rejecting_assessor_invitation': 'Rejecting invitation to become assessor',
  'notifications.assessor_invitation_rejected': 'Invitation to become assessor has been rejected',
  'moduleTitle.participants_list_is_empty': 'Participants list is empty',
  'label.note_from_participant': 'Note from participant',
  'label.you_can_send_aj_to_leader': 'You can now send your Adventurous Journey to your Award Leader for approval.',
  'button.save_report': 'Save report',
  'label.this_activity_has_no_assessor': 'This activity has no Assessor. You must set assessors details before sending it for approval.',
  'label.activity_rejected_click_by_assessor': 'Your activity has been returned by your Assessor. Click for ',
  'button.reject': 'Reject',
  'button.reject_invitation': 'Reject Invitation',
  'label.reason': 'Reason',
  'label.accept_invitation_and_continue': 'Accept invitation and continue',
  'pageTitle.registration_reject': 'Registration reject',
  'errors.you_must_be_older_than_register_for_leader': 'You must be older than {years} years and {months} months to register as an Award Leader.',
  'label.your_report_approve_now_send_to_leader_without_note': 'Your Report has been approved! You can now submit it to your Award Leader for approval.',
  'button.stop_assessing_this_activity': 'STOP ASSESSING THIS ACTIVITY',
  'button.confirm': 'Confirm',
  'moduleTitle.are_you_sure': 'Are you sure?',
  'label.content_restore': 'Content restore',
  'button.stop_editing': 'Stop editing',
  'notifications.activity_has_been_rejected': 'Activity has been rejected',
  'notifications.aj_has_been_rejected': 'Adventurous Journey has been rejected',
  'notifications.rp_has_been_rejected': 'Residential project has been rejected',
  'moduleTitle.additional_files': 'Additional files',
  'moduleTitle.no_additional_files': 'Additional files',
  'moduleTitle.stop_assessing_section': 'Stop assessing section',
  'label.show_security_and_refund_policy': 'Show security and refund policy',
  'moduleTitle.security_and_refund_policy': 'Security and refund policy',
  'label.fees_payment': 'Fees payment',
  'label.redund_policy': 'Refund Policy',
  'label.security_policy': 'Security Policy',
  'label.leave_blank': 'Leave blank',
  'label.frequently_asked_questions': 'Frequently Asked Questions (FAQs)',
  'label.language_selection_is_disabled_for_iac': "Language selection is disabled for IAC's",
  'errors.min_nights_required': 'A minimum of {nights} night(s) is required',
  'label.completion_date': 'Completion Date',
  'label.you_are_offline': 'You are offline. Changes made now may not be saved.',
  'errors.start_date_after_award_start': 'Start date cannot be before current award begun.',
  'label.participants': 'Participants',
  'label.marketing_from_iaf': 'Opt in to receive marketing materials from the International Foundation.',
  'label.marketing_from_oa': 'Opt in to receive marketing materials from the Operating Authority.',
  'label.marketing_from_nao': 'Opt in to receive marketing materials from the NAO.',
  'label.select_iac': 'Select Independent Award Centre',
  'label.you_will_be_redirected_to_the_paypal_payment': 'Click the Pay button above to pay online using your Visa, MasterCard credit card, Visa debit card or PayPal account.',
  'notifications.report_has_been_sent': 'Report has been sent',
  'label.processing_paypal_payment': 'Processing PayPal Payment',
  'label.loading_paypal_gateway': 'Loading PayPal Gateway',
  'label.payment_failed': 'Payment failed',
  'label.payment_has_been_cancelled': 'Payment has been cancelled or failed',
  'roles.naa_oa_staff': 'NAO Staff',
  'label.download_report_and_upload_signed_version': 'Download report and upload signed version',
  'button.download_summary_for_assessor': 'Download summary for assessor',
  'label.pay_online_mastercard': 'Pay Online',
  'label.pay_online_paypal': 'Pay Online',
  'notifications.authorization_code_is_missing': 'Authorisation code is missing',
  'errors.unknown_payment_error': 'Unknown error occured during the payment',
  'errors.already_in_use_by_auth_contact': 'This email is already in use by Authorising Contact',
  'roles.if_staff_stat_user': 'IF Statistical User',
  'moduleTitle.you_have_been_logged_out_due_to_inactivity': 'You have been logged out due to inactivity',
  'announcement.survey_description.do_think_people_are_lazy': "Do you think young people are lazy or entitled? Whether you're a young person or an adult, please fill out one of our global surveys and tell us what YOU think of today's young people.",
  'announcement.survey_title.join_our_global_survey': 'Join our global survey',
  'announcement.survey_button.if_below_25': "If you're 16-25",
  'announcement.survey_button.if_over_25': "If you're over 25",
  'moduleTitle.privacy_and_cookie_policy': 'Privacy and Cookies Policy',
  'label.we_have_made_some_important_changes': "We've made some important changes to our Privacy and Cookies Policy and we want you to know what this means for you and your data.",
  'button.i_agree': 'I agree',
  'button.see_more_details': 'See more detail',
  'label.the_cookie_settings_on_this': 'The cookie settings on this website are set to &quot;allow cookies&quot; to give you the best browsing experience possible. If you continue to use this website without changing your cookie settings or you click &quot;Accept&quot; below then you are consenting to this.',
  'label.after_your_rp_describe': 'Describe your observations from your residential project in a few sentences.',
  'label.you_are_going_to_be_logged_out': "You're going to be logged out due to inactivity."
}
